var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'cursor-wait': _vm.loading,
    'cursor-not-allowed': _vm.disabled,
  }},[_c('button',{class:['w-full', _vm.buttonVariant, { loading: _vm.loading }, { disabled: _vm.disabled }],attrs:{"id":_vm.id,"type":_vm.type,"name":_vm.name,"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.onClick}},[(_vm.loading)?_c('Loader'):_c('span',[_vm._v(_vm._s(_vm.label))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }